module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0015.jpg?v=231a0047";